import React from 'react';

const JobDetail = () => (
  <div className="p-4">
    <h1 className="text-2xl font-bold">Job Title</h1>
    <p>Company: Google</p>
    <p>Location: New York, NY</p>
    <p>Type: Full-time</p>
    <p>Job Description: Lorem ipsum dolor sit amet...</p>
    <button className="mt-4 bg-green-500 text-white px-4 py-2 rounded">Apply Now</button>
  </div>
);

export default JobDetail;
